export default "__VITE_ASSET__BeKQ_W3w__"